module.exports = __webpack_public_path__ + "img/2025_PerformanceMen.1fad41eb.jpg";